import React from "react";
import { Box, WrapItem, WrapItemProps } from "@chakra-ui/react";
import { CSS } from "@dnd-kit/utilities";
import { FiCheck, FiX } from "react-icons/fi";
import { MarkdownRenderer } from "../MarkdownRenderer";
import { useSortable } from "@dnd-kit/sortable";

type WordProps = {
  children: string;
  isCorrect?: boolean;
} & WrapItemProps;

export function Word({ children, isCorrect, ...props }: WordProps) {
  const {
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: children,
  });
  return (
    <WrapItem
      ref={setNodeRef}
      justifyContent="center"
      alignItems="center"
      h="10"
      px="2"
      rounded="md"
      bg="bgSecondary"
      cursor={isDragging ? "grabbing" : "grab"}
      style={{
        transform: CSS.Translate.toString(transform),
        transition,
      }}
      sx={{
        code: {
          fontSize: "inherit",
          bg: "none",
        },
      }}
      {...props}
      {...listeners}
      {...attributes}
    >
      <MarkdownRenderer>{children}</MarkdownRenderer>
      {typeof isCorrect === "boolean" && (
        <Box
          ml="1"
          as={isCorrect ? FiCheck : FiX}
          color={isCorrect ? "success" : "failure"}
        />
      )}
    </WrapItem>
  );
}
